export default "__VITE_ASSET__CwpLuEWG__"